import { Injectable } from '@angular/core';
// import { getStorage, ref, uploadBytesResumable, getDownloadURL, UploadTaskSnapshot } from 'firebase/storage';
import { AngularFireStorage, AngularFireUploadTask } from '@angular/fire/compat/storage';
import * as THREE from "three";
import { AngularFirestore } from '@angular/fire/compat/firestore';
import html2canvas from 'html2canvas';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ScreenshotService2 {

    constructor(private storage: AngularFireStorage) { }

    public takeScreenshot(scene: THREE.Scene, camera: THREE.Camera, renderer: THREE.WebGLRenderer, projectid: string, customerid: string, project: any, afs: AngularFirestore, overwrite: boolean) {
        const originalFogColor = scene.fog?.color;
        const originalBackground = scene.background;

        scene.background = null;
        renderer.render(scene, camera);

        if (!project.imageoverwritten || overwrite) {
            renderer.setClearColor(0x000000, 0);
            renderer.domElement.toBlob((blob) => {
                if (!blob) {
                    console.error('Failed to create blob from canvas');
                    scene.background = originalBackground;
                    if (scene.fog) scene.fog.color = originalFogColor;
                    return;
                }
                // const storage = getStorage(); // Removed: AngularFireStorage handles this
                const imagePath = 'thumbnails/' + projectid + '.png';
                const imageRef = this.storage.ref(imagePath);
                const uploadTask: AngularFireUploadTask = this.storage.upload(imagePath, blob);
                console.log('uploadTask', uploadTask);

                // Optional: Monitor progress
                uploadTask.percentageChanges().subscribe(percentage => {
                    console.log('Upload is ' + percentage + '% done');
                });

                uploadTask.snapshotChanges().pipe(
                    tap(snap => {
                        console.log('snap (snapshotChanges)', snap);
                        if (snap.state === 'running') {
                            // Can add logic here if needed during 'running' state
                        }
                    }),
                    finalize(async () => {
                        try {
                            const url = await imageRef.getDownloadURL().toPromise();
                            console.log('File available at', url);
                            project.image = url;
                            if (overwrite) {
                                project.imageoverwritten = true;
                            }
                            await afs.doc("projects/userprojects/" + customerid + "/" + projectid).update(JSON.parse(JSON.stringify(project)));
                        } catch (error) {
                            console.error("Error in finalize block (getting URL or updating Firestore):", error);
                        } finally {
                            scene.background = originalBackground;
                            if (scene.fog) scene.fog.color = originalFogColor;
                        }
                    })
                ).subscribe(
                    undefined, // Next handler not strictly needed here as finalize covers completion
                    (error: any) => {
                        console.error('Upload error:', error);
                        scene.background = originalBackground; // Restore background on error
                        if (scene.fog) scene.fog.color = originalFogColor; // Restore fog on error
                    }
                );
            }, 'image/png', 1.0);
        } else {
            scene.background = originalBackground;
            if (scene.fog) scene.fog.color = originalFogColor;
        }
    }
}